"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _tinymceReact = require("@tinymce/tinymce-react");
var _InputError = _interopRequireDefault(require("./InputError"));
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputEditor = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 align-bottom col-sm-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row border-bottom pb-2"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.name,
    className: "col-sm-12"
  }, props.label), /*#__PURE__*/_react.default.createElement(_tinymceReact.Editor, {
    className: "col-sm-12",
    apiKey: props.tinyMCEApiKey,
    value: props.value,
    init: {
      images_upload_url: props.uploadUrl,
      file_picker_types: "file image media",
      block_unsupported_drop: true,
      images_upload_credentials: true,
      height: 450,
      width: "100%",
      schema: "html5",
      plugins: "link image code lists advlist autolink media table paste help wordcount fullscreen imagetools",
      toolbar: "insertfile link image | undo redo | formatselect | bold italic | alignleft aligncenter alignright | code removeformat fullscreen"
    },
    onEditorChange: e => props.onChange(e)
  }), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: props.error
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: props.helpText
  }), /*#__PURE__*/_react.default.createElement("hr", null))));
};
var _default = FormInputEditor;
exports.default = _default;